import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const ArrowDown = createSvgIcon(
  <path d="M23.979 6.862 12 18.841.021 6.863l1.591-1.591L12 15.659 22.387 5.271l1.591 1.591Z" />,
  'ArrowDown'
);

export { ArrowDown };
